import { render, staticRenderFns } from "./InventoryTotal.vue?vue&type=template&id=01931a53&scoped=true"
import script from "./InventoryTotal.vue?vue&type=script&lang=js"
export * from "./InventoryTotal.vue?vue&type=script&lang=js"
import style0 from "./InventoryTotal.vue?vue&type=style&index=0&id=01931a53&prod&scoped=true&lang=scss"
import style1 from "./InventoryTotal.vue?vue&type=style&index=1&id=01931a53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01931a53",
  null
  
)

export default component.exports